module.exports = __webpack_public_path__ + "static/media/ceremonie.203cd30e.jpg";